import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getNewsAndEventsRequest, getNewsAndEventsRequestError, getNewsAndEventsRequestSuccess } from "../../slices/NewsAndEvents/GetListSlice";

export const GetNewsAndEventsApi = (page, limit, status, search) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        status: status,
        search: search
    }).toString();

    const urlWithParams = `${endpoints.getNewsAndEventsList}?${queryParams}`;

    try {
        dispatch(getNewsAndEventsRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getNewsAndEventsRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getNewsAndEventsRequestError(_error));
            });
    } catch (error) {
    }
};
